import { BaseApi } from '@/main/baseApi';
import { checkError } from '@/main/services/httpRequest';

import { DMS_MODULE, NAME } from './constants';

class DokladCiselnaRadaProvider extends BaseApi {
	insertDilciCR(data: {}) {
		this.post(`${this.apiPath}InsertDilciCR`, data);
	}

	deleteDilciCR(data: {}) {
		this.post(`${this.apiPath}DeleteDilciCR`, data);
	}

	insertNahradniCR(data: {}) {
		this.post(`${this.apiPath}InsertNahradniCR`, data);
	}

	deleteNahradniCR(data: {}) {
		return checkError(this.axiosInstance.delete(`${this.apiPath}DeleteNahradniCR`, { params: data }), true);
	}

	validate(data: {}) {
		return this.post(`${this.apiPath}CheckNumberSeriesValidations`, data);
	}
	async getDocumentType( dealerKvps: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetDocumentType`, { dealerKvps });
	}
}

export const apiProvider = new DokladCiselnaRadaProvider(DMS_MODULE, NAME);
